import * as types from '../actions/action-types';

const defaults = {
  data: {},
  loading: true
};

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 */
function setData(store, data) {
  return {
    ...store,
    loading: false,
    data: data
  };
}

function setLoading(store){
  return {
    ...store,
    loading:true
  };
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.GET_PLAYER_STATS:
      return setLoading(store);
    case types.RECEIVED_PLAYER_STATS:
      return setData(store, action.data);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/stats-reducer.js